import { Link } from 'react-router-dom';
import { STAGES, stageIndex, type Reel, type Stage } from '@reelmachine/core';

export const STAGE_LABEL: Record<Stage, string> = {
  script: 'Script',
  record: 'Record',
  video: 'Video',
  post: 'Post',
  stats: 'Stats',
};

export function stagePath(reelId: string, stage: Stage): string {
  return `/reels/${reelId}/${stage}`;
}

/** Stage stepper: Script, Record, Video, Post, Stats. Reached stages are links. */
export function Stepper({ reel, current }: { reel: Pick<Reel, 'id' | 'stage'>; current: Stage }) {
  const reached = stageIndex(reel.stage);
  return (
    <nav className="steps" aria-label="Stages">
      {STAGES.map((s, i) => {
        const cls = s === current ? 'cur' : i <= reached ? 'done' : '';
        const content = (
          <>
            <i />
            {STAGE_LABEL[s]}
          </>
        );
        return i <= reached ? (
          <Link key={s} className={cls} to={stagePath(reel.id, s)} aria-current={s === current ? 'step' : undefined}>
            {content}
          </Link>
        ) : (
          <span key={s} className="step" aria-disabled="true">
            {content}
          </span>
        );
      })}
    </nav>
  );
}
